import { actions } from '@search/store/actions/programs';

const programs = (state = [], action) => {
  switch (action.type) {
    case actions.addMultiple:
      Array.prototype.push.apply(state, action.programs);
      return [...state];
    case actions.update:
      const programToUpdate = state.find(p => p.uuid == action.id);
      const programIndex = state.findIndex(p => p.uuid == action.id);

      state.splice(programIndex, 1, {
        ...programToUpdate,
        ...action.data,
      });

      return [...state];
    case actions.clear:
      return [];
    case action.remove:
      return state.filter(p => p.id !== action.id);
    default:
      return state;
  }
};

export default programs;
